<ng-container *ngIf="status == DONE">
<div class="files">
    <!-- show all files with notes -->
    <core-signed-files-list 
        [files]="files" 
        [file]="selectedFile"
        [notes]="notesCounter" 
        [menu]="menu" 
        [scope]="filesContext"
        (menuClick)="onMenuClick($event)" 
        (actionClick)="actionFileClick($event)"
        (iconDownloadClick)="onActionDownloadClick($event)"
        (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()">
    </core-signed-files-list>
</div>

<div class="version-details-preview-file" *ngIf="files.length > 0" >
    <div *ngFor="let file of files; trackBy: trackByFileId">
        <core-pdf-annotations-viewer 
            *ngIf="selectedFile != null && selectedFile.id == file.id && previewStatus == PREVIEW_DONE"
            [file]="selectedFile" 
            [annotationsAllowed]="canCreateNotes" 
            [urlAnnotationsPrefix]="annotationsSaveUrlPrefix"
            [urlAnnotationsLoadPrefix]="annotationsUrlPrefix"
            [context]="previewContext"
            [user]="user"
            (saved)="onSavedAnnotations($event)"
            (refreshSignaturesNeeded)="onRefreshSignaturesNeeded($event)"
            >
        </core-pdf-annotations-viewer>
    </div>
    <ng-container *ngIf="selectedFile != null && previewStatus == PREVIEW_LOADING">
        <div class="loader">
            <div class="dimmed">
                <div class="dimmed_box"></div>
                <div class="dimmed_box_large"></div>
            </div>
        </div>

    </ng-container>
</div>
</ng-container>

